<template>
  <div>
    <h3 class="mb-3 text-dark">Dúvidas</h3>
    <!-- <div class="w-100 mb-3">
      <label>Busca (Nome, Email, CPF/CNPJ)</label>
      <div class="input-group">
        <input v-model="search" class="form-control" placeholder="Escreva aqui a sua busca" @keydown.enter="load(1)" />
        <span class="input-group-append">
          <button @click="load(1)" class="input-group-text"><i class="fa fa-search"></i>Buscar</button>
        </span>
      </div>
    </div> -->
    <div>
      <div class="custom-control custom-switch">
        <input type="checkbox" class="custom-control-input" id="nullAnswer" v-model="open" @change="load(1)">
        <label class="custom-control-label" for="nullAnswer">Mostrar apénas Dúvidas não respondidas</label>
      </div>
    </div>
    <h3 v-if="loading" class="text-center">
      <i class="fa fa-spinner fa-spin"></i>
    </h3>
    <doubts v-for="item in items.data" :key="item.id" :doubt="item"/>
    <pagination :data="items" @pagination-change-page="load"></pagination>
  </div>
</template>

<script>
import Doubt from './../../components/Form/Doubt'
import Axios from 'axios'

export default {
  components: {
    'doubts': Doubt
  },
  data () {
    return {
      items: {},
      page: 1,
      search: undefined,
      loading: false,
      open: false
    }
  },
  methods: {
    load: function ( page=1 ) {
      this.loading = true
      this.page = page
      Axios.get('/admin/doubts', {
        params: {
          page: this.page,
          search: this.search,
          open: this.open
        }
      })
        .then( res => {
          this.items = res.data
        })
        .catch( err => {
          console.error( err )
        })
        .then( () => {
          this.loading = false
        })
    }
  },
  mounted () {
    this.load()
  }
}
</script>

<style>

</style>
